import { ReactNode, useState } from "react";
import "./LeafIconButton.scss";
interface LeafIconButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
  Icon: ReactNode;
  HoverIcon?: ReactNode;
  disabled?: boolean;
  handleHoverInParent?: (val: boolean) => void;
}

export const LeafIconButton = ({
  Icon,
  HoverIcon,
  disabled = false,
  handleHoverInParent,
  ...htmlAttributes
}: LeafIconButtonProps) => {
  return (
    <button
      onMouseEnter={() => handleHoverInParent?.(true)}
      onMouseLeave={() => handleHoverInParent?.(false)}
      disabled={disabled}
      {...htmlAttributes}
      className={`LeafIconButton__button ${htmlAttributes.className ? htmlAttributes.className : ""}`}
    >
      {Icon}
    </button>
  );
};
